angular.module("digitalLeasing.module").component("vendorSelection", {
  templateUrl: "ng/components/digitalLeasing/vendorSelection/vendorSelection.view.html",
  bindings: {
    model: "=",
    onModalityChanges: "&?",
    callNextStep: "&"
  },
  controllerAs: "VendorSelectionCtrl",
  controller: VendorSelectionController
});

function VendorSelectionController(
  $financialApiService,
  $q,
  Bank,
  RiUserG,
  $userService,
  $configService
) {
  var self = this;

  self.user;

  self.allFieldsEmpty = function () {
    var std = Object.keys(self.supportModel.standard).some(function (key) {
      return self.supportModel.standard[key];
    });

    var filiale = Object.keys(self.supportModel.filiale).some(function (key) {
      return self.supportModel.filiale[key];
    });

    /**
     * If both empty, everything is empty
     */
    if (!std && !filiale) {
      return true;
    } else {
      return false;
    }

  };

  self.$onInit = function () {
    self.abiSelected = "";
    self.locationSelected = "";
    self.relatedVendorSelected = "";
    self.cabReturned = true;
    self.supportModel = {
      showSearchButton: true,
      loading: false,
      isStandard: false,
      abiLoader: false,
      cabLoader: false,
      linkedVendorLoader: false,
      standard: {
        piva: "",
        ragSoc: "",
        cf: "",
        ndg: ""
      },
      filiale: {
        ndg: "",
        abi: "",
        location: "",
        cab: ""
      },
      relatedVendor: {
        ndg: null,
        ragSoc: null
      },
      dropdown: {
        abiCode: [],
        cabCode: [],
        relatedVendors: []
      }
    };
    if (self.model.financialVendor.riUserG.piva != null) {
      self.vendorList = [self.model.financialVendor];
    }

    self.user = $configService.getUser();

    retrieveAbi();

    if (self.user.reteVendita == '3' || self.user.reteVendita == '5' || self.user.reteVendita == '4') {
      self.supportModel.showSearchButton = false;
      requestToGetRelatedVendors();
    }

    if (self.model.financialVendor.riUserG.ndg != null && self.model.financialVendor.riUserG.ndg != "" && self.model.financialVendor.riUserG.ragioneSociale != null && self.model.financialVendor.riUserG.ragioneSociale != "") {
      self.supportModel.relatedVendor.ndg = self.model.financialVendor.riUserG.ndg;
      self.supportModel.relatedVendor.ragSoc = self.model.financialVendor.riUserG.ragioneSociale;
    } else {
      self.supportModel.relatedVendor = null;
    }


    if (self.user.reteVendita == '2') {
      self.isBankSelectionCollapsed = false;
      self.isVendorSelectionCollapsed = true;
    } else {
      self.isBankSelectionCollapsed = true;
      self.isVendorSelectionCollapsed = false;
    }

    if ($configService.getAppConfig().allFunctionalities.includes("RICERCA_FILIALI")) {
      self.hideShowFirstRow = false;
    } else {
      self.hideShowFirstRow = true;
    }

  };

  /**
   * Returns a list of vendor
   * @param {*} piva
   * @param {*} ragSoc
   * @param {*} cf
   * @param {*} ndg
   */
  var getVendor = function (piva, ragSoc, cf, ndg) {
    return $q(function (resolve, reject) {
      var vendor = RiUserG.build({
        piva: piva,
        ragioneSociale: ragSoc,
        cf: cf,
        ndg: ndg
      });

      $financialApiService
        .getVendor(vendor)
        .then(function (list) {
          resolve(list);
        })
        .catch(function (error) {
          resolve([]);
        })
        .finally(function () {
          self.supportModel.loading = false;
        });
    });
  };

  /**
   * Returns a list of banks, empty list in case of failure
   * @param {*} ndg
   * @param {*} abi
   * @param {*} location
   * @param {*} cab
   */

  var getBanks = function (ndg, abi, location, cab) {
    return $q(function (resolve, reject) {
      var bank = Bank.build({
        ndg: ndg,
        abi: abi,
        location: location,
        cab: cab
      });

      $financialApiService
        .getBanks(bank)
        .then(function (banks) {
          resolve(banks);
        })
        .catch(function () {
          resolve([]);
        })
        .finally(function () {
          self.supportModel.loading = false;
        });
    });
  };

  /**
   * Calls get vendor or getBanks, returning a list in both cases
   */
  self.search = function () {
    self.supportModel.loading = true;
    self.model.financialVendor.riUserG = null;
    self.model.bank = null;
    /**
     * Se almeno una proprietà è valorizzata, es. cf, allora la ricerca è standard.
     */
    var std = !!Object.keys(self.supportModel.standard).some(function (
      property
    ) {
      return self.supportModel.standard[property];
    });

    if (std) {
      self.supportModel.isStandard = true;
      var standard = self.supportModel.standard;
      getVendor(standard.piva, standard.ragSoc, standard.cf, standard.ndg).then(
        function (vendors) {
          self.vendorList = vendors;
          self.bankList = null;
        }
      );
    } else {
      self.supportModel.isStandard = false;
      var filiale = self.supportModel.filiale;
      var abiSelected = "";
      var cabSelected = "";
      if (filiale.cab) {
        abiSelected = filiale.cab.description
        cabSelected = filiale.cab.name
      } else {
        abiSelected = filiale.abi.value
      }
      getBanks(filiale.ndg, abiSelected, filiale.location, cabSelected).then(
        function (banks) {
          self.bankList = banks;
          self.vendorList = null;
        }
      );
    }
  };

  self.selectVendor = function (vendor) {
    self.model.financialVendor.riUserG = vendor;
    console.log("Vendor avanti: ", self.model.financialVendor.riUserG);
  };

  self.selectBank = function (bank) {
    self.model.bank = bank;
    self.model.financialVendor.filiale = bank;
  };

  var retrieveAbi = function () {
    self.supportModel.abiLoader = true;
    $financialApiService.getAllAbi()
      .then(function (responseAbi) {
        self.supportModel.dropdown.abiCode = responseAbi;

        if (self.supportModel.dropdown.abiCode.length == 1) {
          self.supportModel.filiale.abi = self.supportModel.dropdown.abiCode[0];
          self.checkFieldsChange("abi", self.supportModel.filiale.abi);

        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        self.supportModel.abiLoader = false;
      })
  }

  self.retrieveCab = function (abi, location) {
    if (self.abiSelected != abi || self.locationSelected != location) {
      self.supportModel.dropdown.cabCode = null;
      self.abiSelected = abi;
      self.locationSelected = location;
      self.supportModel.cabLoader = true;
      self.cabReturned = true;

      $financialApiService.getAllCab(abi, location)
        .then(function (responseCab) {
          self.supportModel.dropdown.cabCode = responseCab;
          if (self.supportModel.dropdown.cabCode.length == 0) {
            self.cabReturned = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          self.supportModel.cabLoader = false;
        })
    }
  }


  self.checkInput = function () {
    var filiale = self.supportModel.filiale;
    var standard = self.supportModel.standard;

    var std = !!Object.keys(self.supportModel.standard).some(function (
      property
    ) {
      return self.supportModel.standard[property];
    });

    if (std) {
      if (standard.ndg || standard.piva ||
        standard.cf || standard.ragSoc) {
        return true;
      } else {
        return false;
      }
    } else {
      if (filiale.ndg ||
        (filiale.cab && filiale.abi) ||
        (filiale.abi && filiale.location) ||
        (filiale.cab && filiale.location)) {
        return true;
      } else {
        self.bankList = null;
        return false;
      }
    }
  }

  var requestToGetRelatedVendors = function () {

    self.supportModel.linkedVendorLoader = true;

    $userService.getRelatedVendors()
      .then(function (response) {
        self.supportModel.dropdown.relatedVendors = response.listAppCustomer;
        self.supportModel.linkedVendorLoader = false;
      })
      .catch(function (error) {
        console.log(error);
        self.supportModel.linkedVendorLoader = false;
      })
      .finally(function () {
        console.log("Andata!")
      })

  }

  self.checkFieldsChange = function (property, value) {
    switch (property) {
      case "location":
        if (value && value.value == self.locationSelected) {
          return
        }
        if (value.value && self.supportModel.filiale.abi) {
          self.search();
        } else {
          self.bankList = null;
        }
        break;
      case "abi":
        if (value && value.value == self.abiSelected) {
          return
        }
        if (value.value && self.supportModel.filiale.location) {
          self.search();
        } else {
          self.bankList = null;
        }
        break;
      case "relatedVendor":
        self.model.financialVendor.riUserG.ndg = value.ndg;
        break;
      default:
        break;
    }

    self.supportModel.filiale.cab = null;
    self.cabReturned = true;
  }

  self.callFunctionForNextStep = function () {
    self.callNextStep();
  }

  self.searchWithCab = function () {
    var cabIsPresent = self.supportModel.filiale.cab ? true : false;

    if (self.abiSelected && cabIsPresent ||
      self.locationSelected && cabIsPresent
    ) {
      self.search();
    } else {
      self.bankList = null;
    }
  }
}